export default {
  unsubscribingTitle: 'Are you sure you’re unsubscribing?',
  unsubscribingText:
    'Unsubscribe from all non-critical and non-security related communication',

  unsubscribedTitle: 'You’ve been successfully unsubscribed!',
  unsubscribedText:
    'You will no longer receive non-critical and non-security related communication from ETZ',

  unsubscribeButton: 'Unsubscribe',

  errorTitle: 'Something went wrong',
  errorDescription: 'Please refresh the page or try again later',
};
